const andriodApps = [
	{
		id: 1001,
		title: "My Library",
		url:
			"https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_30/v1618874064/My%20Website%20Projects/mylibrary_gfkxla.jpg",
		description:
			"My Library is an android app which store and manage book collections",
		liveDemo: "https://",
		github: "https://github.com/Mar-Issah/My-Library-Android-App",
		tags: [
			"Android Studio",
			"Java",
			"Glide",
			"Material Design",
			"XML",
			"Animations",
			"Shared Preferences",
			"Recycler View",
			"Git",
		],
	},
	{
		id: 1002,
		title: "Mortgage Calculator",
		url:
			"https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1618874065/My%20Website%20Projects/MortgageCal_ksmmgl.jpg",
		description:
			"This app allows you to estimate your monthly mortgage payment as well as your total paymennt plus interest to pay",
		liveDemo:
			"https://res.cloudinary.com/dytnpjxrd/video/upload/v1618874070/My%20Website%20Projects/myMortgageVid.jpg_aioe21.mp4",
		github: "https://github.com/Mar-Issah/Mortgage-Calculator-Android-App",
		tags: ["Android Studio", "Java", "Material Design", "XML", "Git"],
	},
	{
		id: 1003,
		title: "Stop Watch",
		url:
			"https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_30/v1618446686/My%20Website%20Projects/stopwatch_peidsh.jpg",
		description:
			"This app allows you to set a timer which increases a timer up every one second",
		liveDemo:
			"https://res.cloudinary.com/dytnpjxrd/video/upload/v1618446694/My%20Website%20Projects/stopwatchVid_nvnkkf.mp4",
		github: "https://github.com/Mar-Issah/StopWatch-Android-App",
		tags: ["Android Studio", "Java", "XML", "Git"],
	},
	{
		id: 1004,
		title: " ",
		url: "",
		description: "more awesome app coming soon...",
		liveDemo: "https://",
		github: "https://github.com/Mar-Issah",
		tags: [],
	},
];

export default andriodApps;
